import * as React from "react";
import { MessageSquareMore, MonitorSmartphone, CircleCheck } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
const processSteps = [{
  num: "01",
  title: "Initial Consultation",
  description: "We start with a comprehensive discussion to understand your goals, timeline, and preferences for leaving Illinois.",
  icon: MessageSquareMore,
  badge: null
}, {
  num: "02",
  title: "Needs Assessment",
  description: "We evaluate your specific needs and challenges to create a tailored plan that addresses your unique relocation requirements.",
  icon: MonitorSmartphone,
  badge: "Strategic Review"
}, {
  num: "03",
  title: "Strategic Planning",
  description: "We develop a roadmap that addresses every aspect of your transition, from selling your home to finding your new one.",
  icon: CircleCheck,
  badge: null
}];
export default function ThreeSimpleSteps() {
  return <section data-section-id="224508" id="our-personalized-transition-path" className="bg-background text-foreground py-24 px-6 md:px-12 lg:px-24 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16 md:mb-24">
          <h2 className="text-3xl md:text-5xl font-default font-bold tracking-tight mb-6 text-foreground">
            Our Personalized Transition Path
          </h2>
          <p className="text-lg text-muted-foreground font-default max-w-2xl mx-auto">
            Leaving Illinois doesn’t have to mean chaos. We’ve refined a straightforward process to help you exit with clarity and confidence.
          </p>
        </div>

        <div className="relative">
          {}
          <div className="hidden md:block absolute top-[4.5rem] left-[16.66%] right-[16.66%] h-px border-t-2 border-dashed border-border/20 z-0" aria-hidden="true" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12 relative z-10">
            {processSteps.map((step, index) => <Card key={step.num} data-index={index} className="relative overflow-hidden rounded-md border-border/10 bg-card/40 backdrop-blur-md shadow-lg transition-all hover:bg-card/60 flex flex-col h-full">
                {}
                <span className="absolute -bottom-10 -right-6 text-[180px] font-bold leading-none text-primary/5 select-none pointer-events-none z-0 font-default tracking-tighter" aria-hidden="true">
                  {step.num}
                </span>

                <CardHeader className="relative z-10 pb-4 pt-8 px-8">
                  <div className="w-16 h-16 rounded-sm bg-primary/10 flex items-center justify-center mb-8 border border-primary/30 shadow-sm">
                    <step.icon className="w-8 h-8 text-primary" strokeWidth={1.5} />
                  </div>
                  <div className="flex items-center justify-between gap-4 flex-wrap">
                    <CardTitle className="text-2xl font-default font-semibold text-foreground">
                      {step.title}
                    </CardTitle>
                    {step.badge && <Badge variant="default" className="rounded-sm px-3 py-1 font-default text-xs shadow-sm bg-primary text-primary-foreground">
                        {step.badge}
                      </Badge>}
                  </div>
                </CardHeader>
                
                <CardContent className="relative z-10 px-8 pb-10 flex-grow">
                  <p className="text-muted-foreground font-default leading-relaxed text-base">
                    {step.description}
                  </p>
                </CardContent>
              </Card>)}
          </div>
        </div>
      </div>
    </section>;
}